import { pathOr } from '../helpers/utils';

export const transformedAttribute = (attribute = {}) => {
	const id = pathOr(0, ['id'])(attribute);
	const name = pathOr(0, ['name'])(attribute);

	return {
		name,
		id,
	};
};

export const transformedAttributeList = (attributes = []) => {
	const data = attributes.map((attr) => transformedAttribute(attr));
	return data;
};

export const transformedAttributeInfo = (attribute = {}) => {
	const attributeKeys = pathOr(null, ['attribute_keys'])(attribute);
	return {
		...transformedAttribute(attribute),
		attributeKeys,
	};
};

export const transformedAttributeStatus = (attributes = []) => {
	return attributes.map((item) => ({
		name: item.name,
		id: item.id,
		status: item.status,
	}));
};